import type { SearchFragment, SearchFragmentRest, SearchResultsOverview } from '../../types';
import type { ResponseWithType } from './types';

const searchResultOverview = ({ data: results }: ResponseWithType<SearchFragmentRest[]>): SearchResultsOverview => {
  const { tags, total } = results.reduce(
    (memo, { tag, total }) => {
      memo.tags.push(tag);
      memo.total += total;
      return memo;
    },
    { tags: [], total: 0 } as Omit<SearchResultsOverview, 'resultsOverview'>
  );
  const resultsOverview = results.map<SearchFragment>(({ items, ...overview }) => ({
    ...overview,
    photos: items.map((photo) => {
      return {
        ...photo,
        __typename: 'EventPhoto',
      };
    }),
    __typename: 'SearchFragment',
    id: overview.tag,
  }));
  return { tags, total, resultsOverview };
};

export default searchResultOverview;
